"use strict";
exports.__esModule = true;
require('./code-editor.css');
exports.default = {
  "button": "pf-c-button",
  "codeEditor": "pf-c-code-editor",
  "codeEditorCode": "pf-c-code-editor__code",
  "codeEditorCodePre": "pf-c-code-editor__code-pre",
  "codeEditorControls": "pf-c-code-editor__controls",
  "codeEditorHeader": "pf-c-code-editor__header",
  "codeEditorHeaderMain": "pf-c-code-editor__header-main",
  "codeEditorMain": "pf-c-code-editor__main",
  "codeEditorTab": "pf-c-code-editor__tab",
  "codeEditorTabIcon": "pf-c-code-editor__tab-icon",
  "codeEditorTabText": "pf-c-code-editor__tab-text",
  "modifiers": {
    "readOnly": "pf-m-read-only",
    "control": "pf-m-control",
    "dragHover": "pf-m-drag-hover"
  },
  "monacoEditor": "monaco-editor",
  "themeDark": "pf-theme-dark"
};